import { TFunction } from 'react-i18next';

const mappingTransactionType = (t: TFunction, transactionType?: number) => {
  if (transactionType === 1) {
    return 'DEBIT';
  } else if (transactionType === 2) {
    return 'CREDIT';
  }
};

export { mappingTransactionType };
